import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  constructor(public http: HttpClient, private router: Router) {}
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  base_url = environment.apiUrl;

  createCustomer(data: any): Observable<any> {
    return this.http
      .post(this.base_url + `organization/api-key`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  getCustomers(): Observable<any> {
    return this.http.get(this.base_url + `customer`).pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
  getSingleCustomer(id: string): Observable<any> {
    return this.http.get(this.base_url + `customer/${id}`).pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
}
